<template>
    <div>
<!--        <div class="app-title">-->
<!--            <div>-->
<!--                <h1>{{ $t("app.title.equipmentManagement") }}</h1>-->
<!--            </div>-->
<!--        </div>-->

        <div class="app-title">
            <em-view-title ref="view-title" crudState="cardList"></em-view-title>
        </div>
        <section class="app-content">
            <div class="card-columns">
                <EmCardRouter v-for="cardData in this.routerCards" :key="cardData.id"
                              :cardData="cardData"></EmCardRouter>
            </div>
        </section>
    </div>
</template>


<script>
    import {mapState, mapActions, mapMutations} from "vuex";
    import EmCardRouter from "@/components/em/EmCard/Router";
    import EmViewTitle from "@/components/em/EmViewTitle";

    export default {
        name: "emHome",
        components: {EmCardRouter,EmViewTitle},
        data: function () {
            return {
                show: true
            };
        },
        methods: {
            handleClick: function () {
                this.show = !this.show;
            },
            ...mapActions("emMenu", ["retrieveForRouterCards", "retrieveForUserAclsAndRoles"]),
            ...mapMutations("emMenu", ["setEmMenuBadge", "setStateAttribute"])
        },
        computed: {
            menuId() {
                // 182是后台设备管理模块的menuId
              return this.$route.query.menuId ? this.$route.query.menuId : 182;
            },
            ...mapState({
                routerCards: state => state.emMenu.routerCards
            })
        },
        watch:{
          menuId(){
              this.retrieveForRouterCards(this.menuId);
              this.$refs["view-title"].getMenuTitleData();
          }
        },
        mounted() {
            this.retrieveForRouterCards(this.menuId);
            // 获取当前用户权限
            this.retrieveForUserAclsAndRoles();
        }
    };
</script>


